<style lang="scss">
    .cart-table-remove-item {
        color: #cd6c6c;
        cursor: pointer;
    }
    .collection-remove-item{
        margin-left: 25px;
    }
    .order-items{
        .section-title{
            @apply tw-border-b
              tw-border-0
              tw-border-solid
              tw-text-infinity-primary-text-emphasized
              tw-border-infinity-primary-text-faded-more
              tw-text-lg
              tw-font-medium
              tw-mt-3
              tw-mb-0
              tw-pb-1;
        }

        .row-beat-container{
            border-bottom: 1px solid rgba(200, 200, 200, 0.4) !important;
            padding-top: 5px !important;
            padding-bottom: 5px !important;
            margin-left: 0px !important;
            margin-right: 0px !important;

            .boxed{
                background-image: linear-gradient(135deg, #ff5b94 0%, #8441a4 100%);
                opacity: 0.6;
            }


            .shadow{
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                border: 0;
                border-radius: 5px;
                z-index: 1;
            }

            .item-overlay{
                z-index : 3;
                position: inherit !important;
                .row-beat-container:focus,
                .row-beat-container:hover & {
                    opacity: 1;
                }
            }

            .item-media{
                box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16);
                border-radius: 5px !important;
                height: 52px;
                width : 52px;
                overflow: inherit !important;
                margin-top: 10px;
                margin-bottom: 10px;
            }

            .item-title {
                font-family: Poppins;
                font-weight: 400;
                font-size: 14px !important;
                background: none !important;
                text-overflow : ellipsis;
                margin-left: 10px;
                margin-top: 25px;
            }

            .row-btn-playpause {
                background: #fff !important;
                color: #ff5b94 !important;
                position: absolute !important;
                top: 2px !important;
                left: 2px !important;
                padding: 0 0px !important;
            }

            .quarter {
                width: 15px;
                height: 14px;
                background-color: #ffffff;
                opacity: 0.52;
            }

            .top-right {
                border-top-right-radius: 24px;
                border-bottom-right-radius: 3px;
                border-top-left-radius: 3px;
                position: absolute;
                right: 0;
                top: 0;
            }

            .bottom-left {
                border-bottom-left-radius: 24px;
                position: absolute;
                border-top-left-radius: 3px;
                border-bottom-right-radius: 3px;
                bottom: 0;
                left: 0;
            }

            #circle-container {
                width: 30px;
                height: 30px;
                position:relative;
                z-index:1;
            }

            .center{
                position: absolute;
                padding: 0 !important;
                top: 50%;
                left: 50%;
                margin-top: -15px;
                margin-left: -15px;
            }

            .item-text{
                font-family: Poppins;
                font-weight: 400;
                font-size: 14px;
                text-transform: uppercase;
                margin-top: 25px;
                cursor: pointer;
            }

            .tag-span{
                border-radius: 5px;
                border: 1px solid rgba(200, 200, 200, 0.4);
                height: 16px;
                color: #c8c8c8;
                font-family: Poppins;
                font-size: 8px;
                font-weight: 400;
                width: fit-content;
                padding: 2px;
                margin: 1px;
                display: inline-block;
            }

            .price{
                color: #595e63;
                font-family: Poppins;
                font-size: 14px;
                font-weight: 400;
                margin-top: 25px;
            }

            .item-media-colomn{
                display: -webkit-box;
                overflow: hidden;
                padding-left: 0px !important;
                padding-right: 0px !important;
            }

            .remove{
                margin-top: 30px !important;
                text-align: right;
                cursor: pointer;
                padding-right: 0px !important;
            }
        }

        .row-beat-container:hover  {
            .item-overlay{
                opacity: 1 !important;

            }
        }

        .playing{
            border-radius: 5px !important;
            background-color: #ffedf3 !important;

            .item-overlay{
                opacity: 1 !important;
                display: block !important;
            }

            .tag-span{
                border: 1px solid #595e63 !important;
                color: #595e63 !important;
            }

        }
}
</style>

<template>
<div class="order-items">
    <!-- beats start-->
    <div v-if="beats">
        <h3 class="section-title">Beats</h3>
        <item-container v-for="(beat , index) in beats" :type="'beat'" :element="beat" :key="index"></item-container>
    </div>
    <!-- beats end -->
    <!-- sound packs start -->
    <div v-if="kits">
        <h3 class="section-title">Sound Packs</h3>
        <item-container v-for="(kit , index) in kits" :type="'soundkit'" :element="kit" :key="index"></item-container>
	</div>

    <div v-if="songs">
        <h3 class="section-title">Songs</h3>
        <item-container v-for="(song , index) in songs" :type="'song'" :element="song" :key="index"></item-container>
    </div>
    <div v-if="beattapes">
        <h3 class="section-title">Beat Tapes</h3>
        <item-container v-for="(beattape , index) in beattapes" type="beattapes" :element="beattape" :key="index"></item-container>
    </div>

    <div v-if="services">
        <h3 class="section-title">Services</h3>
        <item-container v-for="(service , index) in services" :type="'service'" :element="service" :key="index"></item-container>
    </div>

    <div v-if="services_quotes">
        <h3 class="section-title">Services Quotes</h3>
        <item-container v-for="(service_quote , index) in services_quotes" :type="'service_quote'" :element="service_quote" :key="index"></item-container>
    </div>
</div>
</template>

<script>
import ItemContainer from './itemcontainer.vue'

export default {
        props:{
            order : Object,
        },
        components : {
            ItemContainer
        },
        created() {
            this.build_order_items(this.order);
        },
        data() {
            return {
                beats : false,
                songs : false,
                kits : false,
                services: false,
                services_quotes: false,
                collections : false,
                beattapes: false
            }
        },
        methods: {

            build_order_items(items){
                this.beats = items.beats
                this.songs = items.songs;
                this.kits = items.kits;
                this.services = items.services
                this.services_quotes = items.services_quotes
                this.collections = items.collections
                this.beattapes = Array.isArray(items.beattapes) && !items.beattapes.length ? null : items.beattapes
             }
        }
    }
</script>
